import { styled } from 'styled-components';

export const PageHeaderTile = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colours.canvas.tertiary.main};
  height: 3rem;
  overflow: hidden;
  position: relative;
  margin: ${({ $margin }) => $margin || '0 0 0 0'};
`;
PageHeaderTile.displayName = 'PageHeaderTile';

export const InfoBar = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  height: 3rem;
  align-items: center;
  padding: ${({ theme }) => `${theme.sizing.small} ${theme.sizing.medium}`};
  ${({ theme }) => theme.typography.headingLarge}

  > div {
    flex: ${({ $cols }) => ($cols === 2 ? ' 0 1 auto' : '1')};
    margin: 0;
    padding: 0;
  }

  > div + div {
    text-align: center;
    flex: 1;

    h3 {
      margin-top: 0;
      color: ${({ theme }) => theme.colours.ink.primary.main};
    }
  }

  > div:last-child {
    text-align: ${({ $cols }) => ($cols === 2 ? 'center' : 'right')};
    justify-content: ${({ $cols }) => ($cols === 2 ? 'center' : 'right')};

    .buttons {
      display: inline-flex;
      gap: ${({ theme }) => theme.sizing.small};
    }
  }

  > div:first-child {
    text-align: left;
    justify-content: flex-start;
  }

  .children {
    display: flex;
    align-items: center;

    > div {
      justify-content: center;
      padding: 0;
    }
  }
`;
InfoBar.displayName = 'InfoBar';

export const Breadcrumb = styled.div`
  display: inline-block;
  vertical-align: middle;
  font-size: ${({ theme }) => theme.typography.bodyMedium.fontSize};
  font-weight: ${({ theme }) => theme.typography.bodyMedium.fontWeight};
  color: ${({ theme }) => theme.colours.ink.primary.main};

  a:hover {
    //color: ${({ theme }) => theme.colours.ink.highlight.weak};
    text-decoration: underline;
  }
`;
Breadcrumb.displayName = 'Breadcrumb';

export const BreadcrumbSection = styled.div`
  display: inline-block;
  margin: 0 ${({ theme }) => theme.sizing.small} 0 0 !important;
`;
BreadcrumbSection.displayName = 'BreadcrumbSection';

export const BreadcrumbDivider = styled.div`
  display: inline-block;
  opacity: ${({ theme }) => theme.opacity.overlay};
  margin: 0 ${({ theme }) => theme.sizing.small} 0 0 !important;
  padding: 0;
  font-size: ${({ theme }) => theme.typography.bodyRegular.fontSize};
  text-align: center;
  color: ${({ theme }) => theme.colours.ink.primary.main};
`;
BreadcrumbDivider.displayName = 'BreadcrumbDivider';
